import { render, staticRenderFns } from "./SearchChat.vue?vue&type=template&id=3f7e7b8f"
import script from "./SearchChat.vue?vue&type=script&lang=js"
export * from "./SearchChat.vue?vue&type=script&lang=js"
import style0 from "./SearchChat.vue?vue&type=style&index=0&id=3f7e7b8f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports